import api from "./api";

export const getCep = async (cep: string) => {
  try {
    const res = await api.get(`/address/getCep/${cep}`);

    return res.data;
  } catch (error: any) {
    throw new Error(
      error.response?.data ||
        error.response?.data?.message ||
        "Erro desconhecido!",
    );
  }
};

export const getCidade = async (estado: string) => {
  try {
    const res = await api.get(`/address/getCidade/${estado}`);

    return res.data.data;
  } catch (error: unknown) {
    if (error instanceof Error) {
      throw new Error(error.message || "Erro ao buscar o produto.");
    } else {
      throw new Error("Erro desconhecido!");
    }
  }
};

export const getCNPJ = async (cnpj: string) => {
  try {
    const clean = cnpj.replace(/\D/g, "");
    const res = await api.get(`/address/getCNPJ/${clean}`);

    return res.data;
  } catch (error: any) {
    throw new Error(
      error.response?.data ||
        error.response?.data?.message ||
        "Erro desconhecido!",
    );
  }
};

export const getEstado = async () => {
  try {
    const res = await api.get("/address/getEstado");
    return res.data.data;
  } catch (error: unknown) {
    if (error instanceof Error) {
      throw new Error(error.message || "Erro ao buscar o produto.");
    } else {
      throw new Error("Erro desconhecido!");
    }
  }
};
